export default (theme) => ({
    tabName: {
        letterSpacing: '0.15px',
        fontSize: 20,
        lineHeight: '24px',
        fontWeight: 500,
        color: "black",
        marginLeft: '12px'
    },
    titleBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: "6px",
        padding: '20px 15px 0 15px'
    },
    addBtn: {
        minWidth: 0,
        width: 39,
        height: 39,
        borderRadius: '50%'
    },
    facilityStatusRoot: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    facilityStatusActiveText: {
        fontWeight: 700,
        color: '#2e7d32',
    },
    facilityStatusInactiveText: {
        fontWeight: 700,
        color: '#d32f2f',
    },
    /** Match SvgIcon color to status label (same hex as *Text classes). */
    facilityStatusActiveIcon: {
        color: '#2e7d32',
    },
    facilityStatusInactiveIcon: {
        color: '#d32f2f',
    },
    facilitiesGridWrap: {
        width: '100%',
        backgroundColor: '#fff',
        '& .main-table': {
            height: 'auto',
        },
    },
});